export default "__VITE_ASSET__b0453d93__"